import { Trans, useTranslation } from "react-i18next";

type LoadImageDropzoneCtaProps = {
  dragCtaKey: "loadImage.dragCtaSingle" | "loadImage.dragCtaMultiple";
};

export const LoadImageDropzoneCta = ({ dragCtaKey }: LoadImageDropzoneCtaProps) => {
  const { t } = useTranslation();

  return (
    <span className="text-gray-600 text-sm">
      <span className="text-blue-700 font-semibold">
        <Trans
          i18nKey="loadImage.clickCta"
          components={{ bold: <span className="font-bold" /> }}
        />
      </span>{" "}
      {t(dragCtaKey)}
    </span>
  );
};
